import React from "react";

const updateList = React.createContext({});

export default updateList;
